export default __webpack_public_path__ + "static/bb-x-bratz-ab08b8cd5c595c93ccab8e45653f572c.webp";